import {useQuery} from "@tanstack/react-query";
import api from "../../utils/api.ts";

const useSavedCount = (type: SaveItemType): number | undefined => {
    const {data} = useQuery<number>({
        queryFn: async () => {
            const res = await api.get(`/persistence/${type}/count`);
            return res.data.count as number;
        },
        queryKey: ['persistence', type, 'count'],
        retry: false
    })

    return data;
}

export default useSavedCount;
